import { useState } from 'react';
import React from 'react';
import Sidebar from '../common/SideBar';
import Topbar from '../common/TopBar';

const Layout = ({ children }) => {
    const [isSidebarExpanded, setIsSidebarExpanded] = React.useState(true);

    const handleToggleSidebar = () => {
        setIsSidebarExpanded(!isSidebarExpanded);
    };
  
    const toggleSidebar = () => setIsSidebarExpanded(!isSidebarExpanded);
  

    return (
        <div className="App">
        <Sidebar isExpanded={isSidebarExpanded} onToggle={handleToggleSidebar} />
        <Topbar onToggle={toggleSidebar} isSidebarExpanded={isSidebarExpanded} />
            <div className="main-content">
                <div className= {`main-content ${isSidebarExpanded ? 'expanded' : ''}`}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Layout;
